import { createContext, ReactNode, useContext } from 'react';
import { useGetGlobalsForWebUi } from '../../api/user';
import { useAuth } from './AuthContext';

export interface ConfigContextProps {
  config: Record<string, any>;
  isLoading: boolean;
  hasError: boolean;
  error?: any;
}

export interface ConfigContextProviderProps {
  children: ReactNode;
}

export const ConfigContext = createContext<ConfigContextProps | undefined>(undefined);

export const ConfigContextProvider = ({ children }: ConfigContextProviderProps) => {
  const { isTokenReady } = useAuth();
  const { data, isLoading, isError, error } = useGetGlobalsForWebUi(isTokenReady);

  const contextValue: ConfigContextProps = {
    config: data?.key_values ?? {},
    isLoading,
    hasError: isError,
    error,
  };

  return <ConfigContext.Provider value={contextValue}>{children}</ConfigContext.Provider>;
};

// Create a custom hook to easily access the ConfigContext
export const useConfig = (): ConfigContextProps => {
  const context = useContext(ConfigContext);
  if (context === undefined) {
    throw new Error('useConfig must be used within a ConfigContextProvider');
  }
  return context;
};
